import script from "./BackLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackLink.vue?vue&type=script&setup=true&lang=ts"

import "./BackLink.vue?vue&type=style&index=0&id=4b5ab0b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5ab0b6"]])

export default __exports__